import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { DynamicFlowStep } from '../model/dynamic-flow.types';

@Injectable({ providedIn: 'root' })
export class DynamicFlowService {
  private readonly http = inject(HttpClient);

  private readonly url = `${environment.url.api}/flow`;

  postStep(flowId: string, flowStep: DynamicFlowStep, navDirection: 'forward' | 'back'): Observable<DynamicFlowStep> {
    return this.http.post<DynamicFlowStep>(`${this.url}/${flowId}/step`, flowStep, {
      params: { direction: navDirection },
    });
  }
}
